import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { AccessControl, MuiButton } from "@ryde/controls";
import { ActionsEnum, DrawerType, useDrawers } from "@ryde/shared";

export const StationsHeaderRightActions: FC = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawers();

  const handleImportStationsClick = useEvent(() => {
    openDrawer({
      drawerProps: {
        type: DrawerType.ImportBusStations,
        title: t("station.formLabel.importBusStations"),
      },
    });
  });

  return (
    <AccessControl entity="system" action={ActionsEnum.AllowImport}>
      <MuiButton onClick={handleImportStationsClick} sx={{ flexShrink: 0 }}>
        {t(`station.formLabel.importBusStations`)}
      </MuiButton>
    </AccessControl>
  );
};
